<template>
  <div :class="getButtonClass" @click="handleClick()">
    {{ getButtonText }}
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "HeaderButtons",
  computed: {
    ...mapGetters("global", ["userIsTrial"]),
    getButtonText() {
      return this.userIsTrial ? this.$t("header.button_access") : this.$t("header.button_points");
    },
    getButtonClass() {
      return [
        "header__button header__button--main link link--bg gtm-button",
        this.userIsTrial ? "gtm-tariff-menu" : "gtm-balance-menu",
      ];
    },
  },
  methods: {
    handleClick() {
      if (this.userIsTrial) {
        this.openPopup();
      } else {
        this.openPoints();
      }
    },
    openPopup() {
      this.$emit("openPopup", "popup");
    },
    openPoints() {
      this.$emit("openPopup", "points");
    },
  },
};
</script>
